import styled from '@emotion/styled';
import { AvailableDeliveryDueDate } from '@kaizenplatform/hugot-entity';
import { Chip, MenuItem, Select, Typography } from '@material-ui/core';
import { createElement, FC, Fragment, useEffect } from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';

import ProductPricing from '../../../entity/ProductPricing';
import { SPACING_UNIT } from '../../constant/spacing';
import { flexibleLayoutContainer } from '../../styleUtility/flexibleLayout';

type Props = {
  // TODO: 特急日の表出制御にのみ使われている。どうしてこれが必要か調べること
  isPointRequired: boolean;
  // TODO: 特急日の表出制御にのみ使われている。どうしてこれが必要か調べること
  productPricing?: ProductPricing;
  availableDeliveryDueDates: AvailableDeliveryDueDate[];
  /** n営業日以内。初期表示時に必要なのでpropsで受け取る */
  deliveryDueDays: number | null;
  /** TODO: onChangeと同じ関数 */
  onMount: (days: number | null, expressDueDays: number) => void;
  /** 対象となる営業日、特急日時を受け取る関数 */
  onChange: (days: number | null, expressDueDays: number) => void;
  className?: string;
};

const AvailableDeliveryDueDateList: FC<Props> = ({
  isPointRequired,
  productPricing,
  availableDeliveryDueDates,
  deliveryDueDays,
  onMount,
  onChange,
  className,
}) => {
  useEffect(() => {
    if (availableDeliveryDueDates.length === 0) {
      return;
    }

    /** 特急n日 */
    let expressDueDays = 0;

    // TODO: deliveryDueDays が 0 ならこの分岐に入らないが本当にそれでいいのか仕様を確認すること。
    if (deliveryDueDays) {
      expressDueDays = availableDeliveryDueDates.find((deliveryDueDate) => deliveryDueDate.days === deliveryDueDays)!
        .expressDueDays;
    }

    onMount(deliveryDueDays, expressDueDays);
    // TODO: Implementation before introducing rules
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (availableDeliveryDueDates.length === 0) {
    return null;
  }

  return (
    <Root className={className}>
      <Label>
        <FormattedMessage id="delivery_due_date.label" />：
      </Label>
      <Select
        value={deliveryDueDays || ''}
        onChange={(e) => {
          const date = e.target.value === '' ? null : Number(e.target.value);

          let expressDueDays = 0;

          if (date) {
            expressDueDays = availableDeliveryDueDates.find((deliveryDueDate) => deliveryDueDate.days === date)!
              .expressDueDays;
          }

          onChange(date, expressDueDays);
        }}
        displayEmpty
      >
        {availableDeliveryDueDates.map((deliveryDueDate) => {
          return (
            <MenuItem key={deliveryDueDate.days} value={deliveryDueDate.days} alignItems="center">
              <FormattedMessage
                id={'available_delivery_due_date.business_days'}
                values={{ days: deliveryDueDate.days }}
              />
              <Spacer />

              {/* YYYY年M月DD日(ddd) */}
              <small>
                <FormattedDate
                  value={deliveryDueDate.dueDate}
                  year="numeric"
                  month="short"
                  day="2-digit"
                  weekday="narrow"
                />
              </small>

              {isPointRequired ? (
                <>
                  <Spacer />
                  <small>
                    {deliveryDueDate.expressDueDays && isPointRequired && productPricing ? (
                      <FormattedMessage
                        id={'creative_format_editor.creation_set_list.express_delivery'}
                        values={{
                          days: deliveryDueDate.expressDueDays,
                        }}
                      >
                        {(text: string) => <Chip label={text} />}
                      </FormattedMessage>
                    ) : null}
                  </small>
                </>
              ) : null}
            </MenuItem>
          );
        })}
        {/*
          deliveryDueDateがnull（指定なし）の場合のみ表示する
          SMB向けUIリリース時に下書きに存在していて納品日が指定なしのプロジェクトに対する処置
          新規プロジェクトに対しては表示しない
        */}
        {deliveryDueDays === null ? (
          <MenuItem value="">
            <FormattedMessage id={'available_delivery_due_date.unspecified'} />
          </MenuItem>
        ) : null}
      </Select>
    </Root>
  );
};

const Root = styled('div')(
  flexibleLayoutContainer({
    direction: 'row',
    alignItems: 'center',
  }),
  {
    minWidth: 120,
  },
);

const Label = styled(Typography)({
  marginRight: SPACING_UNIT,
});

const Spacer = styled('span')({
  marginRight: SPACING_UNIT * 2,
});

export default AvailableDeliveryDueDateList;
